import * as t from 'io-ts';
export const defaultCornerStyle = 'square';
export const CornerStyle = t.keyof({ angled: null, square: null });
export const isCornerStyle = (cornerStyle) => cornerStyle === 'square' || cornerStyle === 'angled';
export const noAdjustment = {
    width: { left: 0, right: 0 },
    depth: { front: 0, back: 0 },
};
export const construct = (sku, width, depth, numberOfSeats, widthLeftOffset = 0, widthRightOffset = 0, depthFrontOffset = 0, depthBackOffset = 0) => ({
    sku,
    numberOfSeats,
    dimensions: { width, depth },
    dimensionAdjustments: {
        width: {
            left: widthLeftOffset,
            right: widthRightOffset,
        },
        depth: {
            front: depthFrontOffset,
            back: depthBackOffset,
        },
    },
});
